<template>
  <nuttrema-layout-content>

    <programs-standard-header
       slot="header"
      :meta="meta"
      :edit.sync="edit"
      :showEdit="true"
      :ProgramDetails="ProgramDetails">
      <template slot="center">
        <nuttrema-group-and-sort class="is-centered">
          <h4 slot="label" class="no-padding is-gray is-uppercase">{{ $t('label.diet_details') }}</h4>
          <h4 slot="content" class="content--title">
            {{ $t('label.schedules') }}<span v-if="selectedDay">, <template v-if="selectedDay.day">{{ selectedDay.day | moment('MMMM Do YYYY') }}</template><template v-else="selectedDay.day">{{ $t('label.day_no', { value: selectedDay.day_number }) }}</template></span>
          </h4>
        </nuttrema-group-and-sort>
      </template>
      <template slot="options">

        <el-dropdown-item>
          <router-link
            :to="{ name: 'copy-diet-day' }">
            <i class="far fa-clone"></i> {{ $t('label.copy_day') }}
          </router-link>
        </el-dropdown-item>

        <el-dropdown-item>
          <router-link
            :to="{ name: 'manage-diet-days' }">
            <i class="far fa-list-alt"></i> {{ $t('label.manage_days') }}
          </router-link>
        </el-dropdown-item>

        <el-dropdown-item class="is-danger">
          <a @click="handleRemoveDaySchedulesClick">
            <i class="far fa-trash-alt"></i> {{ $t('label.remove_day_schedules') }}
          </a>
        </el-dropdown-item>

      </template>
    </programs-standard-header>

    <nuttrema-layout-schedules
       v-if="ProgramDay.ready"
       slot="central"
       width-west="22em"
       min-width-west="2em"
       theme="dc-logo"
      :showTop="haveTitleOrNote">

      <template slot="west">
        <nuttrema-layout-three-vertical class="is-enabled-middle-scroll">
          <program-current-day
             v-if="ProgramDetails.ready"
             slot="top"
            :dayID="dayID"
            :programDays="programDetails.ProgramDays"
            @gotoDay="handleGotoDay">
          </program-current-day>

          <el-collapse
            v-if="ProgramDetails.ready"
            slot="middle"
            v-model="activeWestPanel"
            class="el-collapse--west-block w-100">
            <el-collapse-item
              :title="$t('label.day_of_diet')"
               name="select-day"
               class="el-collapse-item--normal-padding">
              <program-select-day
                 v-if="isDietDetailsReady"
                :id="id"
                :dayID.sync="dayID"
                :programDays="programDetails.ProgramDays"
                :startDate="programDetails.start_date">
              </program-select-day>
            </el-collapse-item>

            <el-collapse-item
               name="nutrition-facts-summary"
               class="el-collapse-item--normal-padding"
              :title="$t('label.day_summary')">
              <nuttrema-loader v-if="!isProgramDaySummaryReady" theme="relative"></nuttrema-loader>
              <nutrition-facts
                 v-else
                 mode="quantity"
                 v-loading="ProgramDaySummary.fetching"
                 element-loading-spinner="el-icon-loading"
                 element-loading-background="rgba(255,255,255, 0.8)"
                :productNutritionFacts="ProgramDaySummary.data">
              </nutrition-facts>
            </el-collapse-item>

            <!-- check permissions for food allergens -->
          <permissions-control-wrapper
             tooltipPlacement="bottom"
             action="permissions.subscribed_plan.food_allergens"
            :clarification="false"
            :permissions="_get(ProgramDaySummary, 'meta.permissions')"
            :required-subscribed-plan="$PERMISSIONS_SUBSCRIBED_PLAN.FOOD_ALLERGENS">
            <el-collapse-item
               slot="allowed"
               name="allergens-summary"
               class="el-collapse-item--normal-padding"
              :title="$t('label.allergens')">
              <nuttrema-allergens-summary
                :allergens="_get(ProgramDaySummary, 'data.allergens')">
              </nuttrema-allergens-summary>
            </el-collapse-item>
          </permissions-control-wrapper>
          <!-- check permissions for food allergens -->

          </el-collapse>
        </nuttrema-layout-three-vertical>
      </template>

      <template slot="west-fold">
        <div class="vertical-fold-content">
          <p class="is-left">{{ $t('label.diet_day_and_summary') }}</p>
        </div>
      </template>

      <template slot="central-top">
        <schedule-day-title
           v-if="isDietDetailsReady"
          :id="id"
          :type="type"
          :dayID="dayID"
          :dietDay="ProgramDay.data"
          @edited="handleProgramDayTitleOrNoteEdit">
        </schedule-day-title>
      </template>

      <template slot="central">
        <nuttrema-loader v-if="ProgramDay.fetching"></nuttrema-loader>
        <program-day-schedules
           v-else
          :id="id"
          :type="type"
          :dayID="dayID"
          :edit="edit"
          @updateSchedulesSequence="onUpdateSchedulesSequence"
          @editSchedule="onEditSchedule"
          @removeSchedule="onRemoveSchedule">
        </program-day-schedules>
      </template>

      <router-view slot="overflow"></router-view>
    </nuttrema-layout-schedules>

    </nuttrema-layout-content>
</template>

<script>
import { mapActions } from 'vuex';
import { get, isNil, first, find } from 'lodash';

import PageProps from 'components/mixins/page-props';

import Emitter from 'components/mixins/emitter';
import * as Event from 'constants/event';

import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';
import ProgramsStandardHeader from 'components/pages/professional/programs/shared/details/cmpt-programs-standard-header';
import NuttremaGroupAndSort from 'components/ui/panels/nuttrema-panel-group-and-sort';

import NuttremaLayoutSchedules from 'components/ui/layout/nuttrema-layout-schedules';
import NuttremaLayoutThreeVertical from 'components/ui/layout/nuttrema-layout-three-vertical';

import ProgramDaySchedules from 'components/pages/professional/programs/shared/schedules/list/cmpt-program-day-schedules';
import ProgramCurrentDay from 'components/pages/professional/programs/shared/schedules/list/cmpt-program-current-day';
import ProgramSelectDay from 'components/pages/professional/programs/shared/schedules/list/cmpt-program-select-day';
import ScheduleDayTitle from 'components/pages/professional/programs/shared/schedules/list/cmpt-schedule-day-title';

import NutritionFacts from 'components/ui/nutrition-information/nutrition-facts';
import NuttremaAllergensSummary from 'components/ui/allergens/nuttrema-allergens-summary';

export default {
  name: 'cmpt-diet-schedules-list',
  mixins: [
    Emitter,
    PageProps,
  ],
  props: {
    id: {
      required: true,
      default: null,
    },
    type: {
      required: true,
      default: null,
    },
    programDetails: {
      required: true,
      default: null,
    },
    initialDayID: {
      required: true,
      default: null,
    },
  },
  components: {
    NutritionFacts,
    ProgramSelectDay,
    ScheduleDayTitle,
    ProgramCurrentDay,
    ProgramDaySchedules,
    NuttremaGroupAndSort,
    NuttremaLayoutContent,
    ProgramsStandardHeader,
    NuttremaLayoutSchedules,
    NuttremaAllergensSummary,
    NuttremaLayoutThreeVertical,
  },
  data() {
    return {
      Event,
      dayID: null,
      edit: false,
      activeWestPanel: ['select-day', 'nutrition-facts-summary', 'allergens-summary'],
    };
  },
  computed: {
    ProgramDay() {
      return this.$store.getters.ProgramDay(this.id);
    },
    ProgramDaySummary() {
      return this.$store.getters.ProgramDaySummary(this.id);
    },
    ProgramDetails() {
      return this.$store.getters.ProgramDetails(this.id);
    },
    selectedDay() {
      return isNil(this.dayID) ? first(this.programDetails.ProgramDays) : find(this.programDetails.ProgramDays, item => Number(item.id) === Number(this.dayID));
    },
    isDietDetailsReady() {
      return this.ProgramDetails.ready;
    },
    isProgramDaySummaryReady() {
      return this.ProgramDaySummary.ready;
    },
    haveTitleOrNote() {
      return !isNil(get(this.ProgramDay, 'data.title')) || !isNil(get(this.ProgramDay, 'data.note'));
    },
    isProgramDayHaveContent() {
      return get(this.ProgramDaySummary, 'meta.food_weight_gr', 0);
    },
  },
  methods: {
    ...mapActions([
      'EditProgramDay',
      'RemoveProgramDaySchedule',
      'RemoveProgramDaySchedules',
      'UpdateProgramDaySchedulesSequence',
    ]),
    fetchProgramDay() {
      if (this.dayID) this.$router.replace({ params: { dayID: this.dayID } });
      this.$store.dispatch('GetProgramDay', { id: this.id, type: this.type, dayID: this.dayID });
      this.$store.dispatch('GetProgramDaySummary', { id: this.id, type: this.type, dayID: this.dayID });
    },
    handleRecreateProgramDaySummaryClick(dayID) {
      console.log('handleRecreateProgramDaySummaryClick clicked');
      this.$store.dispatch('RecreateProgramDaySummary', { id: this.id, type: this.type, dayID });
    },
    handleRemoveDaySchedulesClick(dayID) {
      console.log('handleRemoveDaySchedulesClick clicked', dayID);
      // this.$store.dispatch('RecreateProgramDaySummary', { id: this.id, dayID });
      this.$confirm('This will permanently delete the file. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        const params = {
          id: this.id,
          type: this.type,
          dayID: this.dayID,
        };

        this.RemoveProgramDaySchedules(params).then(() => {
          this.$notify({
            title: this.$t('message.default_success_title'),
            message: 'Remove diet day schedules successfully',
            type: 'success',
            offset: 50,
          });
          this.$store.dispatch('GetProgramDaySummary', { id: this.id, type: this.type, dayID: this.dayID });
        }).catch((error) => {
          this.$notify({
            title: error.error,
            message: error.message,
            type: 'error',
            offset: 50,
          });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled',
        });
      });
    },
    handleProgramDayTitleOrNoteEdit(params) {
      console.log('handleProgramDayTitleOrNoteEdit', params);
      this.EditProgramDay(params).then(() => {
        console.log('edit diet day successfull!');
      }).catch((error) => {
        this.$notify({
          title: error.error,
          message: error.message,
          type: 'error',
          offset: 50,
        });
      });
    },
    handleGotoDay(dayID) {
      this.dayID = dayID;
    },
    onUpdateSchedulesSequence(payload) {
      console.log('onUpdateSchedulesSequence', payload);
      this.UpdateProgramDaySchedulesSequence({
        id: this.id,
        dayID: this.dayID,
        type: this.type,
        payload,
      })
      .catch((error) => {
        console.error(error);
        this.errorNotification();
      });
    },
    onRemoveSchedule(scheduleID) {
      console.log('onRemoveSchedule', scheduleID);
      this.RemoveProgramDaySchedule({
        id: this.id,
        dayID: this.dayID,
        type: this.type,
        scheduleID,
      })
      .then(() => {
        console.log('remove was successfully!');
        this.successNotification({ label: 'label.serving_size', message: 'message.default_success_delete_message' });
        window.Eventus.$emit(Event.SCHEDULES_CHANGED);
      })
      .catch((error) => {
        console.error(error);
        this.errorNotification();
      });
    },
    onEditSchedule(params) {
      const entityType = params.entityType;
      const entityID = params.entityID;
      const scheduleID = params.scheduleID;

      const scheduleType = params.scheduleType;
      const action = scheduleType === 'complex' ? this.meta.navigation.editComplex : this.meta.navigation.editSimple;

      this.$router.push({
        name: action,
        params: {
          entityType,
          entityID,
          scheduleID,
        },
      });
    },
    onShowPage(event) {
      console.log('onShowPage', event);
      this.dispatch('PageDietMainInformation', event);
    },
  },
  watch: {
    id() {
      this.fetchProgramDay();
    },
    dayID() {
      this.fetchProgramDay();
    },
    initialDayID(value) {
      this.dayID = value;
      this.fetchProgramDay();
    },
  },
  created() {
    this.dayID = this.initialDayID;
    this.fetchProgramDay();
    window.Eventus.$on(Event.SCHEDULES_CHANGED, () => {
      console.log('catch Event.SCHEDULES_CHANGED');
      this.$store.dispatch('GetProgramDaySummary', { id: this.id, type: this.type, dayID: this.dayID });
    });
  },
  beforeDestroy() {
    this.$store.dispatch('ClearProgramDay', { id: this.id });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/diets/details/shedules/cmpt-diet-schedules-list.vue